import { render, staticRenderFns } from "./AverageWeightDetailModal.vue?vue&type=template&id=78fa8cf5"
import script from "./AverageWeightDetailModal.vue?vue&type=script&lang=js"
export * from "./AverageWeightDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports